<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">
                <a v-go-back="'contracts'">Contratos</a>
                <i class="right chevron icon divider"></i>
                <a :href="`/contracts/${contract.id}`">{{
                  `${contract.id} - ${contract.owner_name}`
                }}</a>
                <i class="right chevron icon divider"></i>
                <a :href="`/contracts/${contract.id}/associates`">Associados</a>
                <i class="right chevron icon divider"></i>
                <div class="active section">{{ sectionName }}</div>
              </div>
            </Breadcrumb>
          </div>
          <div v-show="persisted" class="eight wide right aligned column">
            <div class="actions">
              <a
                class="section"
                :href="$router.resolve({ name: 'newContract' }).href"
              >
                <i class="plus icon"></i>Novo Contrato
              </a>
              <a @click.prevent="openHistory">
                <i class="history icon"></i>Histórico
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <HistoryModal ref="history" resource="Contract" :item_id="form.id" />
      <UserSearchModal
        ref="client_search_modal"
        title="Selecionar um titular"
        @selected="item => setOwner(item)"
      />
      <UserSearchModal
        ref="member_search_modal"
        title="Selecionar um beneficiário"
        @selected="item => setMember(item)"
      />

      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div :class="[{ error: errors.owner }, 'fields']">
                <div
                  :class="[
                    'four wide required',
                    { error: errors.owner },
                    'field'
                  ]"
                  :data-content="errorsTo('owner')"
                >
                  <label for="contract-form-owner-id">Titular</label>
                  <div class="ui icon input">
                    <input
                      name="contract-form-owner-id"
                      v-focus
                      type="text"
                      id="contract-form-owner-id"
                      v-model="form.owner_id"
                      @blur="setUser($event.target.value, 'owner_name')"
                    />
                    <i
                      class="circular search link icon"
                      @click.prevent="$refs.client_search_modal.open"
                    ></i>
                  </div>
                </div>
                <div class="twelve wide end field">
                  <input
                    disabled
                    type="text"
                    id="contract-form-owner-name"
                    v-model="form.owner_name"
                  />
                </div>
              </div>
              <div>
                <h4 class="ui dividing header">Beneficiários</h4>
                <div v-if="anyMembersError" class="ui error message">
                  <ul class="list">
                    <li
                      v-for="(msg, erroMemberIndex) in errors.members"
                      :key="erroMemberIndex"
                    >
                      {{ msg }}
                    </li>
                  </ul>
                </div>
                <div
                  v-for="(member, index) in members"
                  :key="index"
                  class="ui fields"
                >
                  <div class="four wide required field">
                    <label for="contract-form-owner-id">Beneficiário</label>
                    <div class="ui icon input">
                      <input
                        type="text"
                        class="member-user-id-input"
                        v-model="member.user_id"
                        @blur="
                          setMemberName($event.target.value, 'user_name', member)
                        "
                      />
                      <i
                        class="circular search link icon"
                        @click.prevent="openMemberSearchModel(member)"
                      ></i>
                    </div>
                  </div>
                  <div class="twelve wide end field">
                    <input disabled type="text" v-model="member.user_name" />
                  </div>
                  <div class="remove field">
                    <a
                      class="delete"
                      title="Remover"
                      @click.prevent="removeMember(member)"
                      ><i class="trash icon"></i
                    ></a>
                  </div>
                </div>
                <a @click.prevent="addMember">
                  <i class="plus icon"></i> Adicionar Beneficiário
                </a>
              </div>
            </div>
          </div>
          <!-- row -->
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="save"
                  type="button"
                  name="save"
                  class="ui submit blue button"
                >
                  <i class="save icon"></i>Salvar
                </button>
                <a v-show="persisted" class="delete" @click.prevent="remove">
                  <i class="trash icon"></i>Remover Assiciado
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<style lang="css" scoped>
.warn {
  margin-right: 10px;
}
</style>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import UserSearchModal from '@/components/user_search_modal';
import PageLayout from '@/layouts/page_layout';
import HistoryModal from '@/components/history_modal';
import Feature from '@/utils/features';
import { mapState, mapGetters } from 'vuex';
const sleep = ms => new Promise(res => setTimeout(res, ms));

export default {
  name: 'ContractForm',
  components: {
    Breadcrumb,
    PageLayout,
    UserSearchModal,
    HistoryModal
  },

  data() {
    return {
      loading: false,
      errors: {},
      currentMemberIndex: null,
      contract: {},
      form: {
        id: null,
        owner_id: null,
        owner_name: null,
        owner_person: null,
        obs: null,
        members: []
      }
    };
  },

  computed: {
    persisted() {
      return this.form.id != null;
    },

    sectionName() {
      return this.persisted
        ? `Editar Associado - ${this.form.id}`
        : 'Novo Associado';
    },

    anyError() {
      return !_.isEmpty(this.errors);
    },

    anyMembersError() {
      return (this.errors.members || []).length;
    },

    currentMember() {
      return this.currentMemberIndex != null
        ? this.form.members[this.currentMemberIndex]
        : null;
    },

    members() {
      return this.form.members.filter(b => !b._destroy);
    }
  },

  mounted() {
    this.fetch();
  },

  methods: {
    async fetch() {
      try {
        this.loading = true;
        const contractResponse = await Api.contracts.fetch(
          this.$route.params.contract_id
        );
        this.contract = contractResponse.data.contract;

        if (this.$route.params.id) {
          const contractAssociateResponse = await Api.associates.fetch(
            this.$route.params.contract_id,
            this.$route.params.id
          );

          this.form = contractAssociateResponse.data.associate;
        }
      } catch (err) {
        if (err.response) {
          this.$toast.show('Erro ao buscar dados', 'error');
        } else {
          throw err;
        }
      } finally {
        this.loading = false;
      }
    },

    openHistory() {
      this.$refs.history.open();
    },

    openMemberSearchModel(member) {
      this.currentMemberIndex = this.form.members.indexOf(member);
      this.$refs.member_search_modal.open();
    },

    removeMember(member) {
      if (member.id != null) {
        this.$set(member, '_destroy', true);
      } else {
        const realIndex = this.form.members.indexOf(member);
        this.$delete(this.form.members, realIndex);
      }
    },

    async addMember() {
      this.form.members.push({
        id: null,
        user_id: null,
        user_name: null,
        contract_id: this.contract.id,
        _destroy: false
      });
      await sleep(10);
      $(this.$el).find('.member-user-id-input:last').focus();
    },

    setOwner(item) {
      this.form.owner_id = item.id;
      this.form.owner_name = item.name;
      this.form.owner_person = item.person;
    },

    setMember(item) {
      let member = this.currentMember;
      if (member) {
        member.user_id = item.id;
        member.user_name = item.name;
      }
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    _setErrors(errors) {
      this.errors = _.clone(errors || {});
      setTimeout(() => {
        $('.error.field').popup();
      }, 100);
    },

    save() {
      this.loading = true;
      this._setErrors({});

      let data = _.clone(this.form);
      data.members_attributes = data.members;

      console.log('data', data);

      Api.associates
        .save(this.contract.id, data)
        .then(async response => {
          this.$toast.show('Associado salvo com sucesso', 'success');
          response.data.contract.payment_method =
            response.data.contract.payment_method || {};
          this.form = this._parseContract(response.data.contract);
        })
        .catch(error => {
          if (error.response) {
            const errors = error.response.data.errors;
            const baseErrors = errors && errors.base;
            if (baseErrors && baseErrors.length) {
              this.$toast.show(baseErrors.join(', '), 'error');
            } else {
              this.$toast.show('Erro ao salvar associado', 'error');
            }
            this._setErrors(errors);
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    remove() {
      const removeIt = confirm('Remover Associado?');
      if (removeIt) {
        this.loading = true;
        Api.associates
          .destroy(this.$route.params.contract_id, this.$route.params.id)
          .then(async () => {
            this.$toast.show('Associado removido com sucesso', 'success');
            this.$router.push({ name: 'ContractAssociates', params: { contract_id: this.$route.params.contract_id } });
          })
          .catch(error => {
            if (error.response) {
              const errors = error.response.data.errors;
              const baseErrors = errors && errors.base;
              if (baseErrors && baseErrors.length) {
                this.$toast.show(baseErrors.join(', '), 'error');
              } else {
                this.$toast.show('Erro ao remover associado', 'error');
              }
              this._setErrors(errors);
            } else {
              throw error;
            }
          })
          .finally(() => {
            this.$scrollTop();
            this.loading = false;
          });
      }
    },

    _parseContract(contract) {
      contract.date = contract.date
        ? this.$moment(contract.date, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : null;
      return contract;
    },

    async setUser(id, field) {
      try {
        await sleep(10);
        if (_.isEmpty(this.form[field]) && !_.isEmpty(id)) {
          const response = await Api.users.fetch(id);
          const user = response.data.user;
          this.form[field] = user.name;
          this.form.person = user.person;
        }
      } catch (err) {
        if (err.response) {
          this.$toast.show('Erro ao buscar usuário', 'error');
        } else {
          throw err;
        }
      }
    },

    async setMemberName(id, field, member = null) {
      try {
        await sleep(10);

        if (member && _.isEmpty(member[field]) && !_.isEmpty(id)) {
          const response = await Api.users.fetch(id);
          const user = response.data.user;
          member[field] = user.name;
        }
      } catch (err) {
        if (err.response) {
          this.$toast.show('Erro ao buscar usuário', 'error');
        } else {
          throw err;
        }
      }
    }
  }
};
</script>
